<template>
    <div class="accordion cz2__accordion">
        <h2
            v-if="showAccordionToggle"
            :class="[isKiosk ? 'cz2__ml-layout-double' : 'cz2__ml-layout']"
        >
            <button
                type="button"
                :aria-controls="uniqueId"
                :aria-expanded="`${isOpen}`"
                @click="toggleAccordion"
                class="cz2__accordion-title"
            >
                {{ accordionHeading }}
                <p
                    v-if="quantity > 0"
                    class="cz2__sr-only"
                >
                    {{quantity}} {{ $t('RESULTS') }}
                </p>

                <img
                    v-if="isSpellingBee"
                    src="../../assets/icons/double-chevron-dark-blue.svg"
                    width="24"
                    height="22"
                    alt=""
                    aria-hidden="true"
                    :class="{ rotate: isOpen }"
                    class="cz2__accordion-arrow"
                />
                <img
                    v-else
                    src="../../assets/images/branded/pokemon/pokemon-chevron.svg"
                    width="20"
                    height="16"
                    alt=""
                    aria-hidden="true"
                    :class="{ rotate: isOpen }"
                    class="cz2__accordion-arrow"
                />
            </button>
        </h2>

        <div
            ref="accordionBody"
            :id="uniqueId"
            :class="{ open: isOpen }"
            class="cz2__accordion-body"
        >
            <div class="cz2__accordion-body-content">
                <slot name="body" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__accordion-title {
            margin-bottom: -6px;

            @include font(h1);
            color: black;

            display: flex;
            align-items: center;
            gap: var(--layout-gap);

            cursor: pointer;

            &:focus {
                outline: none;
                text-decoration: underline;
            }

            .selection-category-arrow {
                transition: transform 0.2s linear;
            }
        }

        .cz2__accordion-body {
            display: grid;
            grid-template-rows: 0fr;
            transition: 350ms grid-template-rows ease;

            .cz2__accordion-body-content {
                overflow: hidden;
            }

            &.open {
                grid-template-rows: 1fr;
            }
        }

        .cz2__accordion-arrow {
            transition: transform 0.2s linear;
            transform: rotate(180deg);

            &.rotate {
                transform: rotate(360deg);
            }
        }

        .cz2__accordion:last-child {
            // Because of the negative margin on the header, the last _collapsed_ accordion
            // needs to have a reasonable height.
            // Which should be driven by the accordion body + paddings ideally.
            // Which are 24 + 16 (form group)
            min-height: 24px + 16px - 6px + 24px;
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //   ▗▄▄▖▗▄▄▖ ▗▄▄▄▖▗▖   ▗▖   ▗▄▄▄▖▗▖  ▗▖ ▗▄▄▖    ▗▄▄▖ ▗▄▄▄▖▗▄▄▄▖
    //  ▐▌   ▐▌ ▐▌▐▌   ▐▌   ▐▌     █  ▐▛▚▖▐▌▐▌       ▐▌ ▐▌▐▌   ▐▌
    //   ▝▀▚▖▐▛▀▘ ▐▛▀▀▘▐▌   ▐▌     █  ▐▌ ▝▜▌▐▌▝▜▌    ▐▛▀▚▖▐▛▀▀▘▐▛▀▀▘
    //  ▗▄▄▞▘▐▌   ▐▙▄▄▖▐▙▄▄▖▐▙▄▄▖▗▄█▄▖▐▌  ▐▌▝▚▄▞▘    ▐▙▄▞▘▐▙▄▄▖▐▙▄▄
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    #cz2.cz2__is-sb {
        .cz2__accordion {
            &:first-child {
                @include respond-below(sm) {
                    margin-top: 12px !important;
                }
            }
        }

        .cz2__accordion-title {
            color: color(sbDarkBlue);

            font-family: 'Proxima Nova', sans-serif;
            font-weight: 600;
            font-size: 16px;

            letter-spacing: 1px;

            @include respond-above(lg) {
                font-size: 24px;
            }

            .cz2__accordion-arrow {
                width: 11px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            accordionHeading: {
                type: String,
                default: '',
            },
            showAccordionToggle: {
                type: Boolean,
                default: true,
            },
            index: {
                type: String,
                default: '0',
            },
            quantity: {
                type: Number,
                default: 0,
            },
        },

        data() {
            return {
                isOpen: true,
            };
        },

        computed: {
            uniqueId() {
                return `accordion-body-${this.index}`;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },

        methods: {
            toggleAccordion() {
                if (this.isOpen) {
                    setTimeout(() => {
                        this.$refs.accordionBody.style.visibility = 'hidden';
                    }, 355);
                } else {
                    this.$refs.accordionBody.style.visibility = 'visible';
                }

                this.isOpen = !this.isOpen;
            },
        },
    };
</script>
